import { Keys, type PostKeys, type PostSignUp } from '@/models/login';
import { apiClient } from './apiClient';

class LoginService {

  initService() {}

  async loginUser(keysData: PostKeys) {
    const uri = `/keys/oauth`;
    delete apiClient.defaults.headers.common['X-Date'];
    delete apiClient.defaults.headers.common['Authorization'];
    const res = await apiClient.post(uri, keysData);
    return Keys.mapKeys(res.data);
  }

  async signUp(signUpData: PostSignUp) {
    const uri = `/user`;
    const res = await apiClient.post(uri, signUpData);
    return res.data;
  }
}

export default new LoginService();
